import type { UpdateContractPayload, UpdateContractResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { mapEmptyContractDatesToNull } from '../validations';

import {
  zodUpdateContractPayloadSchema,
  zodUpdateContractResponseSchema,
} from './validations';

/**
 * Updates an existing contract's header fields.
 * Status transitions are validated by the API.
 *
 * @param contractId - The ID of the contract to update.
 * @param payload - The contract fields to update (partial update).
 * @returns The updated contract.
 * @throws Error if the API request fails or validation fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/update_contract_contracts__contract_id__put
 */
export const updateContract = async (
  contractId: UUID,
  payload: UpdateContractPayload,
) => {
  return await vestigasApi
    .put(ENDPOINT.CONTRACT.UPDATE(contractId), {
      json: payload,
      validate: {
        body: zodUpdateContractPayloadSchema.transform(
          mapEmptyContractDatesToNull,
        ),
        response: zodUpdateContractResponseSchema,
      },
    })
    .json<UpdateContractResponse>();
};
